import React from 'react';
import { SvgIcon } from '@material-ui/core';

const CertificateIcon = props => (
  <SvgIcon {...props}>
    <path d="M13 22l2-1 2 1v-7h-4v7zm4-12V8l-2 1-2-1v2l-2 1 2 1v2l2-1 2 1v-2l2-1-2-1zm3-6H4a2 2 0 00-2 2v10a2 2 0 002 2h7v-2H4V6h16v10h-1v2h1a2 2 0 002-2V6a2 2 0 00-2-2zm-9 5H5V7h6v2zm-2 3H5v-2h4v2zm2 3H5v-2h6v2z" />
  </SvgIcon>
);

export default CertificateIcon;
